<template>

    <div class="view pb-2">

        <i-card :viewIndex="card.index"
                :viewCount="1"
                :leftPanel="card.panels.left"
                :rightPanel="card.panels.right"
                :topPanel="card.panels.top"
                :bottomPanel="card.panels.bottom"
                class="i-card mr-2">

            <div class="i-card__main">

                <div class="i-card__main__header">

                    <v-tabs dark
                            background-color="transparent"
                            v-model="headerTabs">

                        <v-tabs-slider color="ycmd-light-green"></v-tabs-slider>

                        <v-tab href="#tab-current">Queue</v-tab>
                        <v-tab href="#tab-archive">Archived</v-tab>

                    </v-tabs>




                    <v-tooltip bottom
                                nudge-bottom="0"
                                nudge-right="40"
                                color="ycmd-black"
                                :disabled="$vuetify.breakpoint.xsOnly"
                                content-class="fade-0 pa-4 pt-2 pb-2">
                        <template v-slot:activator="{ on }">
                            <v-btn icon dark rounded
                                    @click="refreshDataAll"
                                    v-on="on"
                                    class="">
                                <v-icon :size="22" color="">refresh</v-icon>
                            </v-btn>
                        </template>
                        <span>Refresh</span>
                    </v-tooltip>

                    <span
                        class="white--text pl-2 pr-5 text-decoration-underline"
                        :style="`cursor: pointer;visibility:${selectedMessages.length?'visible':'hidden'}`"
                        @click="confirmHeaderSelectionAction()"
                    >
                        {{headerTabs === 'tab-archive' ? 'Restore' : 'Archive'}}
                    </span>


                </div>

                <div class="i-card__main__content br-1">

                    <div class="i-card__scrollable white" >

                        <div class="list-container full-height">
                        <list-messages 
                            :fields="fields"
                            :messages="messages"
                            :page="pageDefinition"
                            @gridScroll="gridScroll"
                            @itemChanged="itemChanged"
                            :tab="headerTabs"
                        />                            
                        </div>
                    </div>
                </div>


            </div>

        </i-card>
        <confirmation
            v-model="confirmMultiselectOperation"
            :title="confirmMultiselectOperationTitle"
            subtitle=""
            :text="confirmMultiselectOperationText"
            @click="confirmationClicked"
            :buttons="[
                    {caption: 'OK'},
                    {caption: 'Cancel'}
                ]"
            max-width="500"
        /> 
    </div>        



</template>

<script>

import ListMessages from './list-messages.vue'
import confirmation from '@/components/modals/confirmation.vue'
import {formatSimple} from '@/methods/formatters';

    export default {
        name: 'notifications',
        components: {
            'list-messages': ListMessages,
            confirmation
        },
        props: {
            changeView: Function
        },
        data() {
            return {
                card: {
                    index: 0,
                    panels: { left: false, right: false, top: false, bottom: false }
                },

                headerTabs: null,
                pageDefinition: {},
                messages: [],
                confirmMultiselectOperation: false,
                nextToken: '0',
                paging: 0,
                loadingMessages: false
            }
        },
        created() {

        },
        async mounted() {

            let promises = [this.$store.dispatch('group/getGroupPage'), this.getMessages(true)]
            let results = await Promise.all(promises)
            let page = results[0]
            console.log('page', page)

            let props = {}
            if (page && Array.isArray(page)) {
                page.map(p => {
                    props[p.id] = p
                })
            }
            this.pageDefinition = props
            console.log('pageDefinition', this.pageDefinition)


        },
        activated() {
          // this.$nextTick(() => this.$refs.searchBarRef.focus());
        },
        methods: {
            itemChanged (payload) {


                let item = payload.item
                if (payload.confirm) {

                    let arr = [item._id]

                    this.removeMessages(arr)
                    this.$toasted.success(`1 Message has been updated`)      
                    
                    this.$store.dispatch('app/syncBadges', {from: 'list', type: 'grouppage_message'})       
                  

                } else {
                    let formatted = this.formatMessage(item)  
                    
                    let index = this.messages.findIndex(m => m._id === formatted._id)
                    if (index > -1) {
                        this.$set(this.messages, index, formatted)
                    }
                }

            },
            gridScroll (params) {
                console.log('gridScroll', params)
                this.onScroll(params)
            },            
            onScroll (params) {
            // console.log(`${new Date}`, params)

            //let window 

                let el = params.srcElement
                console.log(`scrollTop: ${el.scrollTop}, scrollHeight: ${el.scrollHeight} clientHeight: ${el.clientHeight} max: ${el.scrollHeight - el.clientHeight}`)
            
                let lastPage = el.scrollHeight - el.clientHeight

                let current = el.scrollTop + el.clientHeight
                console.log(`lastPage: ${lastPage}, current: ${current} page: ${this.page}`)

                if (current > lastPage && !this.paging) {
                    this.paging = true
                    this.getMessages(false)
                }

            },
            async confirmationClicked (button) {

                this.confirmMultiselectOperation = false
                if (button.caption === 'OK') {
                    let ids = []
                    this.selectedMessages.map(m => {
                        ids.push(m._id)    
                    })
                    
                    let response =  await this.$store.dispatch('group/groupConfirmMessages', {ids: ids, value: this.headerTabs === 'tab-archive' ? false: true})
                    console.log('response', response)
                    let responseValues = {}
                    response.map(r => {
                        responseValues[r.id] = r.value
                    })
                    if (responseValues.status === 'success') {
                        let arr = JSON.parse(responseValues.ids)
                        let len = arr.length

                        if (len){
                            this.$store.dispatch('app/syncBadges', {from: 'list', type: 'grouppage_message'})       
                        }

                        this.removeMessages(arr)
                        this.$toasted.success(`${len} Messages have been updated`)
                    } else {
                        this.$toasted.error('An error has occurred')
                    }
                }
            },
            confirmHeaderSelectionAction () {
                this.confirmMultiselectOperation = true
            },
            formatMessage (m) {
                this.$set(m, 'selected', false)
                let dt = new Date(m.timestamp)
                this.$set(m,'Time Submitted',formatSimple(dt,'MMM dd h:mm a'))
                return m
            },
            removeMessages (ids) {
                let arr = this.messages.filter((message) => !ids.includes(message._id))
                console.log('arr', arr)

                this.$set(this, 'messages', arr)
            },
            async getMessages (clear) {
  
                if (this.nextToken === '99999' || this.loadingMessages) {
                    return
                }
                if (clear) {
                    this.messages = []
                    this.nextToken = '0'
                }
                
                this.loadingMessages = true
                let result = await this.$store.dispatch('group/getGroupPageMessages', {confirmed: this.headerTabs === 'tab-archive' ? true: false, nextToken: this.nextToken})
                console.log('result', result)
                
                let messagesJSON = ''

                result.map(r => {
                    if (r.id === 'messages') {
                        messagesJSON = r.value
                    } else if (r.id === 'nextToken') {
                        this.nextToken = r.value     
                        
                        if (!this.nextToken) {
                            this.nextToken = '99999'
                        }
                    }
                })

                
                if (result.length) {
                    messagesJSON = result[0].value
                }

                let arr = []
                
                if (messagesJSON) {
                    let tempArr = JSON.parse(messagesJSON)
                    tempArr.map(m => {
                        arr.push(this.formatMessage(m))
                    })
                }

                console.log('arr', arr)

                this.messages.push(...arr)

                this.paging = false
                this.loadingMessages = false

            },
            refreshDataAll () {
                this.nextToken = '0'
                this.getMessages(true)
            }

        },
        computed: {
            fields () {
                let arr = []

                if (this.pageDefinition && this.pageDefinition.fields) {

                    let fields = JSON.parse(this.pageDefinition.fields.value)
                    arr.push(...fields)
                }

                return arr
            },
            selectedMessages () {
                let arr = []
                this.messages.map(m => {
                    if (m.selected) {
                        arr.push(m) 
                    }
                })
                return arr
            },
            confirmMultiselectOperationTitle () {
                return `${this.headerTabs === 'tab-archive' ? 'Restore' : 'Archive'} messages?`
            },
            confirmMultiselectOperationText () {
                return `Are you sure you want to ${this.headerTabs === 'tab-archive' ? 'restore' : 'archive'} ${this.selectedMessages.length} messages?`
            }
        },
        watch: {
            headerTabs () {
                this.nextToken = '0'
                this.getMessages(true)
            }
        }
    }

</script>

<style scoped>


</style>
